// extracted by mini-css-extract-plugin
module.exports = {"BackgroundPanel":"BackgroundPanel_BackgroundPanel__8gCo9","Primary":"BackgroundPanel_Primary__2SVS3"};